import { render } from "./BlogImplantsAdditionalProcedure.vue?vue&type=template&id=3f8f2cad"
import script from "./BlogImplantsAdditionalProcedure.vue?vue&type=script&lang=js"
export * from "./BlogImplantsAdditionalProcedure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__